import { Injectable } from '@angular/core';
import { ProgramsSearchGQL } from 'src/generated/graphql';

@Injectable()
export class ProgramService {
  constructor(private programsSearchGQL: ProgramsSearchGQL) {}

  public programsSearch(searchTerm: string) {
    return this.programsSearchGQL.fetch({ searchTerm }, {fetchPolicy: 'network-only'});
  }
}
